// Import the evaluateFilterData function to apply filter conditions
import evaluateFilterData from "./evaluateFilterData";

/**
 * Filters an array of data based on the provided filters.
 * Each item in the data array is evaluated against all the filter conditions.
 * 
 * @param {Array} dataArray - The array of items to be filtered.
 * @param {Object} filters - An object representing the filters to apply, where the keys are the fields to filter by, 
 *                            and the values are objects containing the filter conditions (data and type).
 * 
 * @returns {Array} - The filtered array of data items that meet all filter conditions.
 */
export default function filterData(dataArray, filters) {
  
  // Filter the dataArray by checking each item against the filter conditions
  return dataArray.filter(item => {
    // Check that every filter condition passes for the current item
    return Object.keys(filters).every(key => {
      const filterData = filters[key].data;  // Get the filter value (data)
      const type = filters[key].type;        // Get the filter type (e.g., "number", "string")

      // Check if the item contains the field to be filtered
      if (!(key in item)) return false;

      // Evaluate the filter condition for this field using evaluateFilterData
      return evaluateFilterData(item[key], filterData, type);
    });
  });
}
